export enum InvoiceLockedReason {

    OLD_INVOICE_CANT_BE_DELETED = "OLD_INVOICE_CANT_BE_DELETED",
    INVOICE_CREATED_EXTERNALLY = "INVOICE_CREATED_EXTERNALLY",
    INVOICE_HAS_PAYMENTS = "INVOICE_HAS_PAYMENTS"
}
